export const toastStyles = {
  success: {
    style: {
      border: `1px solid ${p => p.theme.colors.darkTextColor}`,
      padding: `${p => p.theme.spacing(4)}`,
      color: `${p => p.theme.colors.darkTextColor}`,
    },
    iconTheme: {
      primary: '#1f1f1f',
      secondary: '#FFFAEE',
    },
  },
  error: {
    style: {
      border: `1px solid ${p => p.theme.colors.darkTextColor}`,
      padding: `${p => p.theme.spacing(4)}`,
      color: `${p => p.theme.colors.darkTextColor}`,
    },
    iconTheme: {
      primary: '#1f1f1f',
      secondary: '#FFFAEE',
    },
  },

  warning: {
    style: {
      border: `1px solid ${p => p.theme.colors.darkTextColor}`,
      padding: `${p => p.theme.spacing(4)}`,
      color: `${p => p.theme.colors.darkTextColor}`,
    },
    iconTheme: {
      primary: '#1f1f1f',
      secondary: '#FFFAEE',
    },
  },
};
